export default ({ request }) => ({
  techGoodsMaterialListApi(data = {}) {
    return request({
      url: '/factory/tech/goods/material/list',
      method: 'post',
      data,
    })
  },
  techGoodsMaterialDetailApi(data = {}) {
    return request({
      url: '/factory/tech/goods/material/detail',
      method: 'post',
      data,
    })
  },
  techGoodsMaterialDelApi(data = {}) {
    return request({
      url: '/factory/tech/goods/material/del',
      method: 'post',
      data,
    })
  },
  techGoodsMaterialAddSaveApi(data = {}) {
    return request({
      url: '/factory/tech/goods/material/add/save',
      method: 'post',
      data,
    })
  },
  techGoodsMaterialEditSaveApi(data = {}) {
    return request({
      url: '/factory/tech/goods/material/edit/save',
      method: 'post',
      data,
    })
  },
})
